import { TrackAndTrace, useGetGoodsHolderLazyQuery } from '../../generated/graphql'
import { ApolloResult } from '../../common/ApolloResult'
import { GoodsHolderDetails } from './GoodsHolderDetails'
import { GoodsHolderItems } from './GoodsHolderItems'
import { TrackAndTraceEvents } from '../track-and-trace/TrackAndTraceEvents'
import { ShipmentLink } from '../../common/components/links/Links'
import { Icon, Text } from '@nike/eds'
import { BackButton } from '../../common/components/backbutton/BackButton'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { date, format, trackAndTraceExceptionIcon } from '../../common/utils/formatter'
import { TrackAndTraceDetails } from '../track-and-trace/TrackAndTraceDetails'
import { ColumnWithStringAccessorSupport } from '../../common/utils/types'

export function GoodsHolderPage() {
  let { goodsHolderNumber } = useParams()
  const [fetchGoodsHolder, queryResult] = useGetGoodsHolderLazyQuery({
    variables: { goodsHolderNumber },
    context: {
      page: 'goodsholders',
    },
  })

  //Use effect to force refresh when the page is revisited
  useEffect(() => {
    fetchGoodsHolder()
  }, [fetchGoodsHolder, goodsHolderNumber])

  const goodsHolder = queryResult.data?.getGoodsHolder
  const trackAndTraceEvents = queryResult.data?.getTrackAndTraceByGoodsHolder

  return (
    <div className="column-layout--row-gap-24">
      <title className="title">
        <BackButton />
        <Text font="display-4" as="h1">
          {goodsHolder?.packlistNumber && (
            <>
              <ShipmentLink
                packlistNumber={goodsHolder.packlistNumber}
                className="inherit-text-color"
              >
                Packlist {goodsHolder.packlistNumber}
              </ShipmentLink>
              {' - '}
            </>
          )}
          Carton {goodsHolderNumber}
        </Text>
      </title>

      <ApolloResult {...queryResult}>
        {goodsHolder && (
          <>
            <GoodsHolderDetails goodsHolder={goodsHolder} />
            <GoodsHolderItems goodsHolderItems={goodsHolder.goodsHolderItems} />
          </>
        )}
        <TrackAndTraceEvents
          trackAndTraceEvents={trackAndTraceEvents}
          columns={goodsHolderPageTrackAndTraceColumns}
        />
      </ApolloResult>
    </div>
  )
}

const goodsHolderPageTrackAndTraceColumns: ColumnWithStringAccessorSupport<TrackAndTrace>[] = [
  {
    Header: ' ',
    accessor: 'shipmentTrackTrace.event.isException',
    Cell: format(trackAndTraceExceptionIcon),
  },
  {
    Header: 'Time',
    accessor: 'shipmentTrackTrace.event.eventTimestamp',
    Cell: format(date),
  },
  { Header: 'Status', accessor: 'shipmentTrackTrace.event.intermediateStatusCode' },
  {
    Header: 'Description',
    accessor: ({ shipmentTrackTrace }) =>
      !shipmentTrackTrace?.event?.intermediateStatusCode &&
      !shipmentTrackTrace?.event?.intermediateStatusDescription
        ? shipmentTrackTrace?.event?.carrierStatusDescription
        : shipmentTrackTrace?.event?.intermediateStatusDescription,
  },
  { Header: 'Carrier', accessor: 'shipmentTrackTrace.vendor.standardCarrierAlphaCode' },
  { Header: 'Ship Via', accessor: 'shipmentTrackTrace.vendor.shipViaCode' },
  { Header: 'Source', accessor: 'messageControl.sourceSystemName' },
  {
    Header: <Icon name="Report" size="s" />,
    accessor: 'shipmentTrackTrace',
    Cell: ({ value }) => <TrackAndTraceDetails event={value} />,
  },
]
